<div *ngIf="createForm">
  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 6">
    <div class="row">
      <div class="col-md-11">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 6">{{ getIntitule(indexPage) | translate }}</legend>
            <app-step1 *ngIf="indexPage === 1" [uid]="getUid(1)" [parentForm]="form" [disabled]="disabled"
                       [rectificatif]="ann.fnSimple.rectificatifFromFNSimple"
                       [linkForRouter]="linkForRouter"></app-step1>
            <app-step2common *ngIf="indexPage === 2" [uid]="getUidCommon(2)" [parentForm]="form" [disabled]="disabled"
                             [fnSimple]="ann.fnSimple"
                             [linkForRouter]="linkForRouter"></app-step2common>
            <app-step3 *ngIf="indexPage === 3" [uid]="getUid(3)" [parentForm]="form" [disabled]="disabled"
                       [rectificatif]="ann.fnSimple.rectificatifFromFNSimple"
                       [linkForRouter]="linkForRouter"></app-step3>
            <app-step4 *ngIf="indexPage === 4" [uid]="getUid(4)" [parentForm]="form" [disabled]="disabled"
                       [rectificatif]="ann.fnSimple.rectificatifFromFNSimple"
                       [linkForRouter]="linkForRouter"></app-step4>
            <app-step9 *ngIf="indexPage === 5" [uid]="getUid(5)" [parentForm]="form" [disabled]="disabled"
                       [rectificatif]="ann.fnSimple.rectificatifFromFNSimple"
                       [linkForRouter]="linkForRouter"></app-step9>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
